// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BrandListItem__icon":"vl_a bhv_jx","BrandListItem__name":"vl_b bhv_uj"};